/**
 * Milestone 2 · Central role-label registry.
 * Internal role_keys stay in the DB (e.g. `operations_manager`) but every
 * user-facing surface must render the same display name.
 */
export const ROLE_LABEL = {
  super_admin: "Super Admin",
  managing_director: "Managing Director",
  operations_manager: "Team Manager",   // M2-A7 / M2-A16 — never render "Operations Manager"
  accounts_manager: "Accounts Manager",
  accounts: "Accounts",
  hr_manager: "HR Manager",
  hr_admin: "HR Admin",
  team_lead: "Team Lead",
  senior_designer: "Senior Designer",
  designer: "Designer / Draftsman",
  qa_engineer: "QA Engineer",
  trainee: "Trainee",
  viewer: "Viewer",
};

export function roleLabel(roleKey) {
  if (!roleKey) return "";
  return ROLE_LABEL[roleKey] || roleKey.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
}
